import { useState } from "react";
import { Button, InputBase, Stack } from "@mui/material";
import aiChatMessageStyles from "./aiChatMessageStyles";

type AiChatMessageEditorProps = {
  initialContent: string;
  disabled: boolean;
  onCancel: () => void;
  onSave: (content: string) => Promise<void>;
};

export default function AiChatMessageEditor({ initialContent, disabled, onCancel, onSave }: AiChatMessageEditorProps) {
  const [content, setContent] = useState(initialContent);

  return (
    <>
      <InputBase
        value={content}
        onChange={(event) => setContent(event.target.value)}
        multiline
        fullWidth
        disabled={disabled}
        sx={aiChatMessageStyles.editorInput}
      />
      <Stack direction={"row"} spacing={1} sx={aiChatMessageStyles.editorActions}>
        <Button size={"small"} onClick={onCancel} disabled={disabled}>
          Abbrechen
        </Button>
        <Button
          size={"small"}
          variant={"contained"}
          onClick={() => onSave(content)}
          disabled={content === initialContent || disabled}
        >
          Speichern
        </Button>
      </Stack>
    </>
  );
}
